

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLDESIGNATIONS= createAsyncThunk(
  "getAllDesignations/getAllDesignations",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllDesignationsSlice = createSlice({
  name: "getAllDesignationsSlice",
  initialState: {
    getAllDesignations: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllDesignations: (state) => {
        state.getAllDesignations.loading = false
        state.getAllDesignations.error = false
        state.getAllDesignations.data = []
        state.getAllDesignations.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLDESIGNATIONS.fulfilled, (state, action) => {
      state.getAllDesignations = {
        ...state.getAllDesignations,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLDESIGNATIONS.pending, (state, action) => {
      state.getAllDesignations = {
        ...state.getAllDesignations,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLDESIGNATIONS.rejected, (state, action) => {
      state.getAllDesignations = {
        ...state.getAllDesignations,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllDesignationsAction = {
    GETALLDESIGNATIONS,
};

export { getAllDesignationsAction };
export default getAllDesignationsSlice.reducer;
export const {setInitialStateOfgetAllDesignations} = getAllDesignationsSlice.actions
